"use strict";

import angular from "angular";

import template from "./section-grid.component.html";
import "./themes/section-grid.component.scss";
import "./themes/section-grid.component-dark.scss";

class SectionGridComponent {
    constructor() {}

    $onInit() {}
}

export { SectionGridComponent };

const name = "sectionGridComponent";
const def = {
    bindings: {
        sectionHeight: "<",
        row: "<"
    },
    controller: SectionGridComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
